import type { ReactNode } from 'react'

import { cn } from 'src/utils'

export interface PageHeaderLayoutProps {
  title: string
  tabs?: ReactNode
  toolbar?: ReactNode
  children: ReactNode
  className?: string
  contentClassName?: string
}

export const PageHeaderLayout = ({
  title,
  tabs,
  toolbar,
  children,
  className,
  contentClassName,
}: PageHeaderLayoutProps) => {
  const hasStickyRow = Boolean(tabs) || Boolean(toolbar)

  return (
    <div className={cn('flex h-full flex-col overflow-hidden', className)}>
      <div className="flex items-center gap-4 border-b border-gray-200 bg-white px-6 py-3">
        <h1 className="text-xl font-semibold text-doubleNickel-gray-900">
          {title}
        </h1>
      </div>

      {hasStickyRow && (
        <div className="sticky top-0 z-10 flex flex-wrap items-center justify-between gap-3 border-b border-gray-200 bg-white px-6 py-3">
          <div className="flex items-center gap-2">{tabs}</div>
          {toolbar && (
            <div className="flex items-center gap-2">{toolbar}</div>
          )}
        </div>
      )}

      <div className={cn('flex-1 overflow-y-auto px-6 py-5', contentClassName)}>
        {children}
      </div>
    </div>
  )
}

export default PageHeaderLayout
